module.exports = __webpack_public_path__ + "img/get1.b717ce9e.jpg";